import React, { createContext, useContext, useEffect, useState } from 'react';

import AccountsService from '../services/AccountsService';
import { App } from '../services/Types';
import { IRootProps } from './types';

export const ActiveAppKeyContext = createContext<string | undefined>(undefined);
export const AppContext = createContext<App | undefined>(undefined);

interface ProviderProps {
  children?: React.ReactNode;
  props: IRootProps;
}

export const AppContextProvider = ({
  children,
  props,
}: ProviderProps): null | JSX.Element => {
  const [isReady, setIsReady] = useState<boolean>(false);
  const [app, setApp] = useState<App | undefined>();
  const [activeAppKey, _setActiveAppKey] = useState(props?.appKey);

  useEffect(() => {
    const setup = async (appKey: string) => {
      try {
        const app = await AccountsService.getApp(appKey, {
          includeAppStoreInfo: true,
          includeBranding: true,
          includeFeatures: true,
        });
        setApp(app);
        setIsReady(true);
      } catch (e) {
        console.warn(e);
        setIsReady(true);
      }
    };

    if (activeAppKey) {
      setup(activeAppKey);
    }
  }, [activeAppKey]);

  if (!isReady) {
    return null;
  }

  return (
    <ActiveAppKeyContext.Provider value={activeAppKey}>
      <AppContext.Provider value={app}>{children}</AppContext.Provider>
    </ActiveAppKeyContext.Provider>
  );
};

export const useAppContext = (): App | undefined => {
  return useContext<App | undefined>(AppContext);
};

export const useActiveAppKey = (): string | undefined => {
  return useContext<string | undefined>(ActiveAppKeyContext);
};
